import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.teams',
		defaultMessage: 'Teams',
		description: 'The link label for Teams',
	},
});
